import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { cloneElement, PureComponent } from 'react';
// eslint-disable-next-line @repo/internal/react/no-class-components
export default class Coordination extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      shouldRenderChildren: false
    });
    _defineProperty(this, "stop", async () => {
      const {
        client,
        messageId
      } = this.props;
      try {
        await client.stop(messageId);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(`Unable to stop flow message ${messageId}. ${err}`);
      }
    });
  }
  async componentDidMount() {
    const {
      client,
      messageId
    } = this.props;
    try {
      const started = await client.start(messageId);
      if (started) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
          shouldRenderChildren: true
        });
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(`Unable to start flow message ${messageId}. ${err}`);
    }
  }
  injectStop(children) {
    return /*#__PURE__*/cloneElement(children, {
      stop: this.stop
    });
  }
  render() {
    const {
      fallback,
      children
    } = this.props;
    const {
      shouldRenderChildren
    } = this.state;
    return shouldRenderChildren ? this.injectStop(children) : fallback;
  }
}
_defineProperty(Coordination, "defaultProps", {
  fallback: null
});